import { DeliveryMethods } from '~/api/ETA';

/** Delivery method name the app used before it adopted the ETA v3 vocabulary. */
const LEGACY_COURIER_DELIVERY = 'JIFFY_DELIVERY';

/**
 * Accepts a delivery method from outside the app — persisted checkout state or
 * an order placed before the rename — and returns the current name for it.
 *
 * TODO: remove once no stored state can still carry `JIFFY_DELIVERY`, i.e. a
 * couple of releases after this ships.
 */
export const normalizeDeliveryMethod = <T extends DeliveryMethods | undefined>(
  method: T | string,
  fallback: DeliveryMethods = DeliveryMethods.COURIER_DELIVERY,
): DeliveryMethods => {
  if (method === LEGACY_COURIER_DELIVERY) {
    return DeliveryMethods.COURIER_DELIVERY;
  }

  if (
    method === DeliveryMethods.COURIER_DELIVERY ||
    method === DeliveryMethods.CLICK_AND_COLLECT
  ) {
    return method;
  }

  return fallback;
};
